<div class="top-header position-sticky top-0">
    <div class="container">
        <div class="d-flex align-items-center w-100 justify-content-center justify-content-md-star px-0 pe-0 pe-xl-0 py-3">
            <div class="d-md-flex d-none align-items-center gap-2 logo-left logo-tradder">
                <!-- <ng-container *ngFor="let i of socialicon">
                    <a href="javascript:void(0);"><img src="assets/images/social/{{i.icon}}" class="w-24-px h-24-px" alt="name" /></a>
                </ng-container> -->
                <img src="../../../../assets/images/logo/GovMahaLog.png" alt="name" />
                <span class="d-lg-flex d-none">{{ 'Government of Maharashtra' | translate | async }}</span>
            </div>
            <div class="emb-icon d-none d-sm-block"> 
                <a href="https://www.india.gov.in/" class="d-inline-block">
                    <img class="w-75-px h-60-px" src="../../../../assets/images/svg/emb-black.svg" title="{{ 'National Portal of India' | translate | async }}" alt="Emblem" />
                </a>
            </div>
            <!-- <div class="d-flex align-items-cetner gap-2 ms-md-auto me-3">
                <ng-container *ngFor="let i of socialicon">
                    <a href="javascript:void(0);"><img src="assets/images/social/{{i.icon}}" class="w-24-px h-24-px" alt="name" /></a>
                </ng-container>
            </div> -->
            <!-- <h6 class="mx-auto mb-0 text-center d-md-flex d-none align-items-center">{{ 'Government of Maharashtra' | translate | async }}</h6> -->
            <!-- <div class="warning-text">
                 {{ 'This Website is for Testing Purpose Only' | translate | async }}
            </div> -->
            <div class="logo-tradder d-flex right-end-content">
            <h6 *ngIf="!this.consentAccessService.isLoggedIn"
                class="btn btn-sm btn-flat skip-main-content border-0 mb-0 d-md-flex d-none align-items-center justify-content-center" (click)="scrollToSection('Statistics')">
                {{ 'Skip to main content' | translate | async }}
            </h6>
            <!-- border-start -->
            <!-- <a [routerLink]="'/home/sitemap'"
                class="btn btn-sm btn-flat rounded-0 border-0 border-end border-white text-white d-flex align-items-center justify-content-center p-2 w-30-px tabButton"
                data-bs-toggle="tooltip" aria-label="Sitemap" data-bs-placement="bottom"
                [attr.data-bs-title]="'Sitemap'|translate|async">
                <i class="fa fa-sitemap" aria-hidden="true"></i>
            </a> -->
            
            <!-- <a href="#" (click)="false;" class="btn btn-sm btn-flat rounded-0 border-0 border-start d-flex align-items-center justify-content-center p-2 w-30-px" data-bs-toggle="tooltip" data-bs-placement="bottom" [attr.data-bs-title]="'Search'|translate|async">
                <i class="fa-x-search"></i>
            </a> -->

            <!-- <a class="btn btn-sm btn-flat rounded-0 border-0 border-start border-white d-flex align-items-center justify-content-center text-white p-2 w-30-px tabButton" data-bs-toggle="tooltip" data-bs-placement="bottom" [attr.data-bs-title]="'Text to Speech'|translate|async" (click)="textToSpeechService.toggleSpeech()">
                <i class="fa fa-headphones" [ngClass]="{'enabled': textToSpeechService.isEnabled()}"></i>
            </a> -->
            <!-- <div class="btn-group eq-button d-flex align-items-stretch" role="group">
                <button title="Text Zoom Out" type="button" class="btn btn-sm btn-flat rounded-0 border-0 border-start d-flex align-items-center justify-content-center p-2" (click)="decreaseValue($event)"><i class="fa fa-x-minus"></i></button>
                <button title="Normal Text" type="button" [class]="'text-light' | themeSwitch" class="btn btn-sm h-100 rounded-0 border-0 btn-primary d-flex align-items-center justify-content-center p-2" (click)="resetValue($event)"><i class="fa fa-font"></i></button>
                <button title="Text Zoom In" type="button" class="btn btn-sm h-100 rounded-0 btn-flat border-0 border-end d-flex align-items-center justify-content-center p-2" (click)="increaseValue($event)"><i class="fa fa-x-plus"></i></button>
            </div> -->
            <!-- <div class="dropdown">
                <button
                    class="btn btn-sm btn-flat rounded-0 border-0 border-start border-end border-white d-flex align-items-center text-white justify-content-center px-3 py-0 h-100 w-50-px tabButton"
                    type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false"
                    [title]="'Accessibility'|translate|async">
                    <div class="w-20-px h-20-px rounded-3 ">
                        <div class="pulser">
                            <img src="../../../../assets/images/svg/Accessbility.png" />
                        </div>
                    </div>
                </button>
                <ul class="dropdown-menu min-w-100-p max-w-100-p p-0 rounded-0" aria-labelledby="dropdownMenuButton">
                    <li *ngIf="getZoom()!=='text-smaller'">
                        <button
                            class="dropdown-item p-0 text-center h-30-px d-flex align-items-center justify-content-center"
                            (click)="decreaseValue($event)" title="Text Zoom Out" data-bs-toggle="tooltip"
                            data-bs-placement="right">
                            <i class="fa fa-x-font-minus"></i>
                        </button>
                    </li>
                    <li>
                        <button
                            class="dropdown-item p-0 text-center h-30-px d-flex align-items-center justify-content-center"
                            (click)="resetValue($event)" title="Normal Text" data-bs-toggle="tooltip"
                            data-bs-placement="right">
                            <i class="fa fa-x-font-normal"></i>
                        </button>
                    </li>
                    <li *ngIf="getZoom()!=='text-larger'">
                        <button
                            class="dropdown-item p-0 text-center h-30-px d-flex align-items-center justify-content-center"
                            (click)="increaseValue($event)" title="Text Zoom In" data-bs-toggle="tooltip"
                            data-bs-placement="right">
                            <i class="fa fa-x-font-plus"></i>
                        </button>
                    </li>
                </ul>
            </div> -->
            <ul class="dropdown-menu p-2 rounded-3 border-0 accessibility-menu" aria-labelledby="dropdownMenuButton">
                <div class="d-flex align-items-center justify-content-between px-2 accessibility-wrapper mx-2">
                    <button
                        *ngIf="getZoom() !== 'text-smaller'"
                        class="btn btn-sm btn-light border-0 p-0"
                        (click)="decreaseValue($event)"
                        title="Text Zoom Out">
                        <img src="../../../../assets/images/svg/minus-icon.svg" alt="Decrement" />
                    </button>
                    <span class="accessibility-text">Aa</span>
                    <button
                        *ngIf="getZoom() !== 'text-larger'"
                        class="btn btn-sm btn-light border-0 p-0"
                        (click)="increaseValue($event)"
                        title="Text Zoom In">
                        <img src="../../../../assets/images/svg/plus-icon.svg" alt="Increment" />
                    </button>
                </div>
            </ul>

            <div class="d-flex align-items-center gap-1 px-2 lang-block">

                <!-- <div class="bhashini-plugin-container">

                </div> -->

                <!-- <button class="btn btn-flat btn-sm text-white">
                    {{ selectedLanguage }}
                    </button> -->
                <!-- {{ currentLanguage | translate | async } -->
                <!-- <label class="form-label text-capitalize mb-0 me-1">{{'language' | translate | async}}</label> -->
                <div class="dropdown d-flex">
                    <button class="btn btn-flat btn-sm dropdown-toggle fw-medium h-100 border-0 border-white py-1 language-bg" type="button" id="lang-dropdown" data-bs-toggle="dropdown" aria-expanded="false" [title]="'Change language'|translate|async">
                        {{ currentLanguage | translate | async }}
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end rounded-0 p-0 mt-2" aria-labelledby="lang-dropdown">
                        <li *ngFor="let item of listItems"><a class="dropdown-item" [class.active]="item.value==langService.currentLanguage" href="#" (click)="langService.changeLanguage(item.value);false;">{{ item.name | translate | async }}</a></li>
                    </ul>
                </div>
            </div>
            
            <!-- <a class="btn btn-sm btn-flat rounded-0 border-0 border-end border-white d-flex align-items-center justify-content-center text-white p-2 w-30-px tabButton"
                data-bs-toggle="tooltip" data-bs-placement="bottom"
                [attr.data-bs-title]="'Text to Speech'|translate|async" (click)="textToSpeechService.toggleSpeech()">
                <img src="../../../../assets/images/svg/Social Media.svg" />
            </a> -->
            <div class="theme-block px-2 ms-2">
                <div class="d-flex align-items-center justify-content-center">
                    <span class="theme-text mx-1">{{ 'Theme' | translate | async }}</span>
                    <button *ngFor="let theme of themes"
                            type="button"
                            class="w-20-px h-20-px mx-1"
                            [ngClass]="[theme + '-color', currentTheme === theme ? 'active' : '']"
                            (click)="setTheme(theme)">
                    </button>
                    <!-- <a   false;" class="btn btn-sm btn-flat rounded-0 border-0 border-end border-white text-white border-start border-white d-flex align-items-center justify-content-center px-3 py-1 w-40-px tabButton" data-bs-toggle="tooltip" data-bs-placement="bottom" [attr.data-bs-title]="(switchTo|translate|async)||('')">
                        <i [class]="iconClass"></i>
                    </a>-->
                </div>
                </div>
            </div>
        </div>
    </div>
</div>
